'use client';

export { GlobalErrorPageSport as default } from '@svenskaspelab/nova-foundation/nextjs/pages';
